export const appHead = {"link":[{"rel":"icon","href":"/android-icon-144x144.png","type":"image/png","sizes":"144x144"},{"rel":"icon","href":"/android-icon-192x192.png","type":"image/png","sizes":"192x192"},{"rel":"icon","href":"/android-icon-36x36.png","type":"image/png","sizes":"36x36"},{"rel":"icon","href":"/android-icon-48x48.png","type":"image/png","sizes":"48x48"},{"rel":"icon","href":"/android-icon-72x72.png","type":"image/png","sizes":"72x72"},{"rel":"icon","href":"/android-icon-96x96.png","type":"image/png","sizes":"96x96"},{"rel":"icon","href":"/apple-icon-114x114.png","type":"image/png","sizes":"114x114"},{"rel":"icon","href":"/apple-icon-120x120.png","type":"image/png","sizes":"120x120"},{"rel":"icon","href":"/apple-icon-144x144.png","type":"image/png","sizes":"144x144"},{"rel":"icon","href":"/apple-icon-152x152.png","type":"image/png","sizes":"152x152"},{"rel":"icon","href":"/apple-icon-180x180.png","type":"image/png","sizes":"180x180"},{"rel":"icon","href":"/apple-icon-57x57.png","type":"image/png","sizes":"57x57"},{"rel":"icon","href":"/apple-icon-60x60.png","type":"image/png","sizes":"60x60"},{"rel":"icon","href":"/apple-icon-72x72.png","type":"image/png","sizes":"72x72"},{"rel":"icon","href":"/apple-icon-76x76.png","type":"image/png","sizes":"76x76"},{"rel":"icon","href":"/apple-icon-precomposed.png","type":"image/png","sizes":"192x192"},{"rel":"icon","href":"/icon-16x16.png","type":"image/png","sizes":"16x16"},{"rel":"icon","href":"/icon-32x32.png","type":"image/png","sizes":"32x32"},{"rel":"icon","href":"/icon-96x96.png","type":"image/png","sizes":"96x96"},{"rel":"icon","href":"/ms-icon-144x144.png","type":"image/png","sizes":"144x144"},{"rel":"icon","href":"/ms-icon-150x150.png","type":"image/png","sizes":"150x150"},{"rel":"icon","href":"/ms-icon-310x310.png","type":"image/png","sizes":"310x310"},{"rel":"icon","href":"/ms-icon-70x70.png","type":"image/png","sizes":"70x70"},{"rel":"apple-touch-icon","href":"/apple-icon.png","type":"image/png","sizes":"192x192"},{"rel":"apple-touch-icon","href":"/apple-touch-icon.png","type":"image/png","sizes":"180x180"}],"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"property":"og:image","content":"og-image.png"},{"property":"og:image:type","content":"image/png"},{"property":"og:image:width","content":512},{"property":"og:image:height","content":512},{"name":"twitter:image","content":"og-image.png"},{"name":"twitter:image:type","content":"image/png"},{"name":"twitter:image:width","content":512},{"name":"twitter:image:height","content":512},{"name":"twitter:site","content":"@zenodotfm"},{"name":"twitter:card","content":"summary_large_image"},{"property":"og:image","content":"/og-image.png"},{"property":"og:type","content":"website"}],"style":[],"script":[{"src":"https://www.googletagmanager.com/gtag/js?id=G-BPTE0F3T9Q","async":true},{"children":"\n            window.dataLayer = window.dataLayer || [];\n            function gtag(){dataLayer.push(arguments);}\n            gtag('js', new Date());\n\n            gtag('config', 'G-BPTE0F3T9Q', { 'send_page_view': false });\n          ","type":"text/javascript"}],"noscript":[],"charset":"utf-8","viewport":"width=device-width, initial-scale=1","htmlAttrs":{}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"trailingSlash":"append","componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false